import InvoiceCreateContainer from "@legacy/invoices/InvoiceCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { INVOICES_ROUTES } from "@routes/invoices"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function InvoiceEdit() {
    const invoiceId = window.INVOICE_ID
    const isDraft = window.INVOICE_IS_DRAFT

    const [detailsRoute] = useSlugExtractor([INVOICES_ROUTES.DETAILS], invoiceId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("invoices_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle
                            label={isDraft ? "New Invoice" : "Edit Invoice"}
                            backDestination={detailsBackDestination}
                        />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <InvoiceCreateContainer formMode="EDIT_INVOICE" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
